import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/ReadyForAdventureSection/ReadyForAdventureSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { OFF_ROAD_LANDING_REF } from 'views/rebranded-module/OffRoadToursLandingViewV2/utils/constants';

const ReadyForAdventureSection = () => {
  const content = useContent('OffRoadLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const tourLink = PATHS.tour.index(
    content.adventureTourType,
    content.adventureSlug,
    {
      ref: OFF_ROAD_LANDING_REF,
    },
  );
  return (
    <StyledBox>
      <Box className="RFASBackground">
        <ImgBox
          image={{
            src: getSizedImage(content.advantureBackground),
            alt: content.advantureBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Box className="RFASGradient" />
      <Container maxWidth="xl" className='RFASContentContainer'>
        <Box className="RFASContent">
          <Typography variant="h3" component="h2" >
            {content.adventureTitle}
          </Typography>
          <Typography variant="body1" component="p" my={2} color="text.secondary">
            {content.adventureDescription}
          </Typography>
          <Button
            component={NavigatorLink}
            href={tourLink}
            className="RFASBtn"
            variant="contained"
            color="primary">
            {content.bookTourBtnLabel}
          </Button>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { ReadyForAdventureSection };
